import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'kt-fill-form',
  templateUrl: './fill-form.component.html',
})
export class FillFormComponent {
  input: { data: any } = { data: {} };

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public form: {
      title: string;
      schema: { components: any[] };
      input: { data: any };
      viewMode: boolean;
    },
    private dialogRef: MatDialogRef<FillFormComponent>,
  ) {}

  handleInputChange(data: any): void {
    if (data) this.input = { data };
  }

  closeDialog(event: Event): void {
    event.stopPropagation();

    this.dialogRef.close();
  }

  submit(event: Event): void {
    event.stopPropagation();

    this.dialogRef.close(this.input);
  }
}
